<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Users</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">App Users

        <div style="margin-right: 15px;">
            <button mat-raised-button color="primary" style="font-size: 14px;
                margin-right: 15px;" (click)="Add_User()"><mat-icon>add</mat-icon>Add</button>
        </div>
    </div>
</div>


<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <div class="table-responsive">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Search</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
        </mat-form-field>
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" recycleRows>
            <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
            </ng-container>
            <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef aria-label="row actions">Action</th>
                <td mat-cell *matCellDef="let element" style="display: flex;align-items: center;">

                    <button mat-raised-button matTooltip="Navigate to Event Admin"
                        style="margin-right: 5px;background: green;color: white;"
                        (click)="Go(element.UserID, element.Mobile)">
                        Go
                    </button>

                    <button mat-raised-button color="primary" style="margin-right: 5px;"
                        (click)="Edit_User(element.UserID)" matTooltip="Edit User">
                        <mat-icon class="m-0">edit</mat-icon>
                    </button>

                    <button mat-raised-button color="warn" style="margin-right: 5px;"
                        (click)="DeleteUser(element.UserID)" matTooltip="Delete">
                        <mat-icon class="m-0">delete</mat-icon>
                    </button>

                    <button mat-raised-button (click)="View_Event(element.UserID)"
                        style="background-color: green;color: white;" matTooltip="Event List">
                        <mat-icon class="m-0">event_note</mat-icon>
                    </button>

                    <button mat-icon-button aria-label="expand row"
                        (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()"
                        matTooltip="Stall List">
                        <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                        <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                    <div class="example-element-detail"
                        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                        <div *ngIf="element.so_events && element.so_events.length > 0; else noEvents">
                            <table mat-table [dataSource]="element.so_events" style="background: #f9e25a;">
                                <!-- Define columns for event details -->
                                <ng-container matColumnDef="event_name">
                                    <th mat-header-cell *matHeaderCellDef> Event Name </th>
                                    <td mat-cell *matCellDef="let event"> {{event.event_name}} </td>
                                </ng-container>

                                <ng-container matColumnDef="company_name">
                                    <th mat-header-cell *matHeaderCellDef> Company Name </th>
                                    <td mat-cell *matCellDef="let event"> {{event.company_name}} </td>
                                </ng-container>

                                <ng-container matColumnDef="copy_link">
                                    <th mat-header-cell *matHeaderCellDef> Copy Stall Catalogue Link </th>
                                    <td mat-cell *matCellDef="let event">
                                        <button mat-icon-button color="primary" (click)="copySoLink(event.so_id)">
                                            <mat-icon>content_copy</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <!-- Add more columns as needed -->

                                <tr mat-header-row *matHeaderRowDef="['event_name', 'company_name', 'copy_link']"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['event_name', 'company_name', 'copy_link']">
                                </tr>
                            </table>
                        </div>
                        <ng-template #noEvents>
                            <p style="background: #f9e25a;">No Stall found.</p>
                        </ng-template>
                    </div>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
            <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
    </div>


    <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>